<script>
import { mapGetters, mapActions } from 'vuex'
import { groupBy, orderBy, forEach } from 'lodash'
import dayjs from '@services/date/index'

export default {
  data() {
    return {
      sortedNotifyingBookings: [],
      feebackMenu: false,
    }
  },
  computed: {
    ...mapGetters({
      pendingFeedback: 'pendingfeedbacks/pendingFeedback',
      getSelectedClients: 'client/getSelectedClients',
      getUserForEventLogging: 'auth/getUserForEventLogging',
      hasCreateBookingPermissionForAtleastOneClientLocation:
        'auth/hasCreateBookingPermissionForAtleastOneClientLocation',
    }),
    canCreateBookings() {
      return this.hasCreateBookingPermissionForAtleastOneClientLocation(
        this.getSelectedClients[0] // TODO: Rework to use multiple clients
      )
    },
    feedback() {
      return this.pendingFeedback(this.getSelectedClients[0]) // TODO: Rework to use multiple clients
    },
  },
  watch: {
    feedback: {
      deep: true,
      handler() {
        this.processPendingFeedbackData()
      },
    },
    feebackMenu: {
      handler() {
        if (this.feebackMenu) {
          this.trackClick()
        }
      },
    },
  },
  async mounted() {
    if (!this.canCreateBookings) return

    var result = await this.getPendingFeedback(this.getSelectedClients[0]) // TODO: Rework to use multiple clients

    if (!result.isSuccess) {
      if (result.statusCode === 403)
        alert(this.$t('pendingFeedbacks.pendingFeedbacksUnauthorisedError'))
      return
    }

    this.processPendingFeedbackData()
  },
  methods: {
    ...mapActions({
      getPendingFeedback: `pendingfeedbacks/getPendingFeedbacks`,
      trackClickEvent: 'trackClickEvent',
    }),
    processPendingFeedbackData() {
      var notifyingBookings = []
      // grouped by candidated id
      var groupedBookings = groupBy(this.feedback, (x) => x.candidateID)

      forEach(groupedBookings, (bookings, candidateId) => {
        // bypass feedback already provided
        var feedbackProvided = bookings.find(
          (booking) => booking.feedbackCompleted
        )

        if (feedbackProvided != null) {
          return
        }
        var sorted = orderBy(bookings, 'endTimeUTC', 'asc')
        // add last booking into array
        notifyingBookings.push(sorted[sorted.length - 1])
      })

      // sort list again for final display, latest booking ones first
      this.sortedNotifyingBookings = orderBy(
        notifyingBookings,
        'endTimeUTC',
        'desc'
      )
    },
    displayTimeAgo(feedbackData) {
      const convertDate = dayjs(feedbackData.endTimeUTC)
        .tz(feedbackData.locationTimezone, false)
        .fromNow()
      return convertDate
    },
    trackClick() {
      this.trackClickEvent({
        name: 'feedback_menu_clicked',
        properties: this.getUserForEventLogging,
      })
    },
  },
}
</script>

<template v-if="canCreateBookings">
  <v-menu
    v-if="sortedNotifyingBookings.length > 0"
    v-model="feebackMenu"
    bottom
    :close-on-click="true"
    :close-on-content-click="false"
    :nudge-width="150"
    nudge-bottom
    offset-y
    max-width="400"
  >
    <template v-slot:activator="{ on: menu }">
      <v-list
        id="pending-feedbacks-list"
        :title="
          `${$tc(
            'pendingFeedbacks.pendingFeedbacksSubTitle',
            sortedNotifyingBookings.length,
            {
              n: sortedNotifyingBookings.length,
            }
          )}`
        "
        class="py-0 transparent"
        width="100px"
        height="72"
      >
        <v-list-item class="pb-2" v-on="{ ...menu }">
          <v-list-item-content class="text-right">
            <v-list-item-title class="pr-6">
              <v-badge
                color="blue"
                :content="`${sortedNotifyingBookings.length}`"
              >
                <v-icon>mdi-bullhorn</v-icon>
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>

    <v-card>
      <v-list dense>
        <v-subheader>Pending feedback(s)</v-subheader>

        <template v-for="(item, i) in sortedNotifyingBookings">
          <v-list-item :key="`pending_feedback_item_${item.candidateID}`">
            <v-list-item-content>
              <v-list-item-title>{{ item.candidateName }}</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-list-item-action-text>{{
                displayTimeAgo(item)
              }}</v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>

          <v-divider
            v-if="i < sortedNotifyingBookings.length - 1"
            :key="`pending_feedback_item_divider_${i}`"
          ></v-divider>
        </template>
      </v-list>
    </v-card>
  </v-menu>
</template>

<style lang="scss" module>
@import '@styles';
</style>
